const openEnded = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "open-ended",
    items: [
      { id: "q1", question: "Le texte de l'invite 1", answers: [], image: null },
      { id: "q2", question: "Le texte de l'invite 2", answers: [], image: null },
      { id: "q3", question: "Le texte de l'invite 3", answers: [], image: null },
      { id: "q4", question: "Le texte de l'invite 4", answers: [], image: null },
      { id: "q5", question: "Le texte de l'invite 5", answers: [], image: null },
    ],
  },
  botId: "nualang.open-ended.0.0.1",
  botName: "open_ended",
  description: "open_ended_desc",
  difficulty: "ALL",
  learnLang: "french",
  name: "",
  botAvatar: "",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-comment-dots?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Bienvenue
   
  Dites "Bonjour" à bot pour commencer.`,
  voice: "",
  versionQuestion: "Combien de questions souhaitez-vous dans ce modèle?",
};

export default openEnded;
